export default function Carregando({ texto = 'Carregando…' }) {
  return (
    <div className="carregando">
      <div className="spinner" aria-hidden="true" />
      <p>{texto}</p>
    </div>
  );
}
